import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PrivacyContent from '../components/PrivacyContent';

const PrivacyPage = () => {
  const navigate = useNavigate();

  // Same safe-back behavior as TermsPage so deep-link visits don't strand
  // the user (Apple review opens deep links in a fresh process).
  const handleBack = () => {
    const hasHistory =
      typeof window !== 'undefined' && window.history && window.history.length > 1;
    if (hasHistory) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <button
          onClick={handleBack}
          className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 mb-6"
          data-testid="privacy-back-button"
        >
          <ArrowLeft className="h-4 w-4" /> Back
        </button>

        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-400 mb-8">Last updated: May 2026</p>

        <PrivacyContent />
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
